import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface GetEnabledChoicesResponse extends BackendResponse {
  items: string[];
}

export interface GetEnabledChoicesParameters extends NextApiParams {
  allowcache: boolean;
  test: boolean;
}

export const getEnabledChoices = withNextApi<
  GetEnabledChoicesResponse,
  GetEnabledChoicesParameters
>("/cvp/CvpGetEnabledChoices", { method: "GET" });
